import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';
import type { FormTemplate } from './types';

export const getFormTemplatesAPI = async () => {
  const response = await baseAPI.get<Array<FormTemplate>>('forms/templates');
  return response.data;
};

export const useGetFormTemplates = () => {
  return useQuery(
    queryOptions({
      queryKey: QUERY_KEYS.FORM_TEMPLATES(),
      queryFn: () => getFormTemplatesAPI(),
    }),
  );
};
